import { DropdownFilter } from "../../../../components/Filters/DropdownFilter";
import { ContentTypeChooser } from "../ContentTypeChooser";
import { useSearchContext } from "../../contexts";
import { useTranslation } from "react-i18next";

interface ContentTypesChooserDropdownProps {
  onOpenChange?: (isOpen: boolean) => void;
}

export const ContentTypesChooserDropdown: React.FC<ContentTypesChooserDropdownProps> = ({ onOpenChange }) => {
  const { state } = useSearchContext();
  const { t } = useTranslation();
  return (
    <DropdownFilter
      title={t("Content types")}
      counter={state.draftFilters.contentTypes.value.length}
      isExclude ={state.draftFilters.contentTypes.exclude}
      onOpenChange={onOpenChange}
    >
      <ContentTypeChooser />
    </DropdownFilter>
  )
};
